import { useServicesContext } from "@modules/core/services/services.context"
import { CustomerHistoryEntity } from "@modules/finances/entities/customerHistoryEntity"
import { useQuery } from "@tanstack/react-query"

export enum UseTransactionsHistoryKeys {
  BOX = "boxTransactionsHistory",
  USER = "userTransactionsHistory",
}

export const useTransactionsHistory = (
  apiKey: UseTransactionsHistoryKeys,
  stripeCustomerId: string,
  size = 20,
  page?: string,
) => {
  const { userFinanceApi, boxFinanceApi } = useServicesContext()
  const financeApi = apiKey === UseTransactionsHistoryKeys.BOX ? boxFinanceApi : userFinanceApi

  const { data, isLoading } = useQuery({
    queryKey: [apiKey, stripeCustomerId, size, page],
    queryFn: async () => {
      return await financeApi.getTransactionsHistory(stripeCustomerId, page, size)
    },
  })

  return {
    data: data?.data.map((customerHistoryDto) => CustomerHistoryEntity.fromDto(customerHistoryDto)) || [],
    isLoading,
    hasMore: data?.hasMore || false,
    nextPage: data?.nextPage || undefined,
  }
}
